import React, { Component } from "react";
// import { Modal } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import ModalHelpers from "./ModalHelpers";
import TraffickingDataStore from "../../Flux/Stores/TraffickingDataStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import WorkbookStore from "../../Flux/Stores/WorkbookStore";
import { startMappingProcess } from "../../Flux/Actions/TraffickingActions";
import { Notification } from "carbon-components-react";
import LoadingIcon from "../../Components/LoadingSpinner";
import Dropdown from "@acadia-ui/dropdown";
import "./traffickingModal.scss";
import "./modal.scss";
import { getPlatformAdvertisers } from "../../Flux/Actions/MasterCampaignActions";
const initialState = {
	selectedAdvertiser: null
};
const formEl = "platform_advertiser_modal";
class PlatformAdvertiserModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...initialState,
			open: false,
			loading: false
		};
	}

	componentDidMount() {
		this.props.platformAdvertiserModal(this);
		getPlatformAdvertisers({ masterPlatformID: 1 });
		TraffickingDataStore.on("mapping_success", this.closeModal);
		TraffickingDataStore.on("mapping_fail", this.closeModal);
	}

	componentWillUnmount() {
		this.props.platformAdvertiserModal(undefined);
		TraffickingDataStore.removeListener("mapping_success", this.closeModal);
		TraffickingDataStore.removeListener("mapping_fail", this.closeModal);
	}

	closeModal = () => {
		this.setState({ loading: false, ...initialState, open: false });
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
			this.setState({ ...initialState, loading: false });
			if (this.state.open === false) {
				if (WorkbookStore.getMetaData().AdvertiserName !== null) {
					if (MasterCampaignsStore.getPlatformAdvertisers().length) {
						MasterCampaignsStore.getPlatformAdvertisers().forEach((advertiser) => {
							if (advertiser.label === WorkbookStore.getMetaData().AdvertiserName) {
								this.setState({ selectedAdvertiser: advertiser });
							}
						});
					}
				}
			}
		});
	};

	updateModalState = () => {
		this.state.open ? Modal.hide(formEl) : Modal.show(formEl);
		this.setState({ open: !this.state.open });
	};

	startTraffickingRequest = (e) => {
		e.preventDefault();
		TraffickingDataStore.resetMappingErrors();
		this.setState({ loading: true }, () => {
			startMappingProcess(
				// this comment exists to prevent eslint from making this unreadable.
				this.props.campaignMetaData.CampaignUniqueIDCode,
				this.state.selectedAdvertiser.value
			).finally(() => {
				Modal.hide(formEl);
			});
		});
	};

	render() {
		return (
			<Modal
				className="platformAdvertiserModal"
				id={formEl}
				heading="Verify with Google Campaign Manager"
				onRequestClose={() => {
					this.triggerOpenClose();
				}}
				actionSetProps={{
					actionsRight: (
						<>
							<Button
								onClick={(e) => {
									e.stopPropagation();
									this.triggerOpenClose();
								}}
								display={BUTTON_DISPLAY.SECONDARY}
								data-tracking-id-alt="cancel-platform-advertiser"
							>
								Cancel
							</Button>
							<Button disabled={this.state.selectedAdvertiser === null} onClick={this.startTraffickingRequest} data-tracking-id-alt="submit-platform-advertiser">
								Submit
							</Button>
						</>
					)
				}}
				onClick={() => {}}
			>
				{MasterCampaignsStore.getPlatformAdvertisers()?.length ? (
					<div style={{ paddingBottom: "200px" }}>
						<Dropdown
							id={"requestPriority"}
							value={this.state.selectedAdvertiser}
							options={MasterCampaignsStore.getPlatformAdvertisers()}
							onChange={(selected) => this.setState({ selectedAdvertiser: selected })}
							placeholder="Select Advertiser..."
							invert={true}
							isSearchable={true}
							isClearable={true}
						>
							Select an Advertiser
						</Dropdown>
					</div>
				) : (
					<Notification
						key="advertiserMissing"
						kind="error"
						role="inline"
						title="No advertiser available for selection"
						subtitle=""
						hideCloseButton
						iconDescription="No advertiser available for selection"
					/>
				)}
				{this.state.loading && <LoadingIcon />}
			</Modal>
		);
	}
}

export default PlatformAdvertiserModal;
